var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTradeSharpenerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 594.1 589.6",
    style: {
      enableBackground: "new 0 0 594.1 589.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#231F20;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M594,11.2l-3.5,47.4c-0.4,5.2-5.1,9.3-10.3,8.9c-5.4-0.4-9.4-5.1-9-10.4l1.7-23.4L56.2,539l0.1,0 l449.5-151.8l21.3-259l0.4-0.5l20.6-20l-23.4,287.4c-0.1,1.2-0.5,2.4-1.1,3.5c-0.2,0.5-0.5,0.8-0.8,1.3c-0.4,0.5-0.7,1-1.2,1.5 l-0.1,0.1c0,0,0,0.1-0.1,0.1l-175,166.9l23.6,1.7c5.2,0.4,9.3,5.1,8.9,10.5c-0.4,5.2-5.1,9.3-10.3,8.9l-47.4-3.5 c-2.7-0.2-5.2-1.5-6.8-3.6c-1.6-2.1-2.3-4.7-2-7.4l3.2-45.8c0.4-2.7,1.8-5.1,3.9-6.7c2.1-1.4,4.6-2.1,7.1-1.7 c5.2,0.8,8.9,5.6,8.3,10.9l0,20.8l141.9-135.2L10.1,571.1l0,0l172.3-463.5L33.8,249.2l23.9,1.8c5.4,0.4,9.4,5.1,9,10.4 c-0.4,5.4-5.1,9.4-10.5,9L9,266.8c-2.7-0.2-5.2-1.5-6.8-3.6c-1.7-2.1-2.5-4.7-2-7.4L3.4,210c0.3-2.5,1.7-5,3.9-6.6 c2-1.6,4.4-2.1,7-1.7c5.3,0.6,9,5.6,8.4,10.8l0,20.5L200,63.9c0.5-0.5,1.2-0.8,1.7-1.2c0.4-0.1,0.6-0.4,1-0.7l0.1,0 c1-0.5,2.1-0.7,3.4-0.7c0.1-0.1,0.2-0.1,0.4-0.1l278.9-17.2l-23,20.7l-0.5,0.1L213.5,80.3L42,525.7L559.5,19.8l-20.7-0.3l-0.6,0 c-5-0.4-9.1-4.7-9-9.9c-0.1-2.5,1-4.8,2.7-6.7c1.8-1.8,4.5-2.9,7.2-2.9l45.4,0.8c2.7-0.1,5.2,1.1,7,3.1 C593.3,5.8,594.2,8.5,594,11.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeSharpenerLogo);
export default __webpack_public_path__ + "static/media/trade_sharpener_logo.89d7bca189b2879c1c5906573cadf71d.svg";
export { ForwardRef as ReactComponent };